export const PRIVACY_ATTEMPT = "PRIVACY_ATTEMPT";
export const PRIVACY_SUCCESS = "PRIVACY_SUCCESS";
export const PRIVACY_FAILED = "PRIVACY_FAILED";

export const PRIVACY_UPDATE_SUCCESS = "PRIVACY_UPDATE_SUCCESS";
export const PRIVACY_UPDATE_FAILED = "PRIVACY_UPDATE_FAILED";
export const LOGOUT = "LOGOUT";